module.exports = __webpack_public_path__ + "static/media/AboutDap.9602db7d.png";